import { Injectable } from '@angular/core';
import { AvlaRestClientService } from 'base-angular-avla';
import { DatePipe } from '@angular/common';

@Injectable()
export class ValidatorService {
  constructor(
    protected restClientService: AvlaRestClientService,
    protected datePipe: DatePipe
  ) {}
  // https://es.wikipedia.org/wiki/ISO_3166-1
  // guia iso 3166-1 para validar paises
  private listCountries: string[] = ['CL', 'PE', 'CO'];

  /**
   * Valida que un RUT tenga un número identificador correcto
   * @param {string} dni
   * @return {*}  {boolean}
   * @memberof ValidatorService
   */
  public validateRutLastDigit(dni: string): boolean {
    if (!dni || dni.trim() == '') {
      return false;
    }
    if ('CL' == dni.substring(0, 2)) {
      dni = dni.substring(2, dni.length);
    }
    let valChar = dni.slice(-1).toUpperCase();
    let rut = dni.substring(0, dni.length - 1);
    if (isNaN(+rut)) {
      return false;
    }
    let i = 2;
    let sumaRUT = 0;
    rut = this.reverse(rut);
    for (let char of rut) {
      let n = parseInt(char);
      sumaRUT = sumaRUT + n * i;
      i++;
      if (8 === i) {
        i = 2;
      }
    }
    let resto = sumaRUT % 11.0;
    let valReal = 11 - resto;
    let valRealStr: string;
    if (10 === valReal) {
      valRealStr = 'K';
    } else if (11 === valReal) {
      valRealStr = '0';
    } else {
      valRealStr = valReal.toString();
    }
    return valChar === valRealStr;
  }

  public reverse(str: string) {
    return str.split('').reverse().join('');
  }

  public validateCountrie(cd: string) {
    if (cd in this.listCountries) {
      return true;
    }
    return false;
  }

  public formatRUT(s: string) {
    let rutReverse: string = this.reverse(s);
    let i: number = 0;
    let rutReversePuntos: string = '';
    let a = true;
    for (let char of rutReverse) {
      i++;
      if (2 === i && a) {
        rutReversePuntos = rutReversePuntos + '-';
        i = 0;
        a = false;
      }
      if (0 === i % 3 && 0 != i) {
        rutReversePuntos = rutReversePuntos + '.';
      }
      rutReversePuntos = rutReversePuntos + char;
    }
    return this.reverse(rutReversePuntos);
  }

  public formatRUTsinPuntos(s: string) {
    let rutReverse: string = this.reverse(s);
    let i: number = 0;
    let rutReversePuntos: string = '';
    for (let char of rutReverse) {
      i++;
      if (2 === i) {
        rutReversePuntos = rutReversePuntos + '-';
      }
      rutReversePuntos = rutReversePuntos + char;
    }
    return this.reverse(rutReversePuntos);
  }

  public rutToDni(rut: string) {
    if (!rut) {
      return '';
    }
    if ('CL' == rut.substring(0, 2)) {
      rut = rut.substring(2, rut.length);
    }
    let dni: string =
      'CL' + rut.split('.').join('').split('-').join('').split(' ').join('');
    return dni;
  }

  // transforma dni = "CL169410313" en RUT = "16.941.031-3"
  public dniToRut(dni: string) {
    if (!dni) {
      return '';
    }
    if ('CL' == dni.substring(0, 2).toUpperCase()) {
      dni = dni.substring(2);
    }
    let rutReverse: string = this.reverse(dni);
    let i: number = 0;
    let rutReversePuntos: string = '';
    let a = true;
    for (let char of rutReverse) {
      i++;
      if (2 === i && a) {
        rutReversePuntos = rutReversePuntos + '-';
        i = 0;
        a = false;
      }
      if (0 === i % 3 && 0 != i) {
        rutReversePuntos = rutReversePuntos + '.';
      }
      rutReversePuntos = rutReversePuntos + char;
    }
    return this.reverse(rutReversePuntos);
  }

  public setTimeLocal(t): string {
    return this.datePipe.transform(
      new Date(t).getTime() - new Date().getTimezoneOffset() * 60000,
      'HH:mm:ss dd/MM/yyyy '
    );
  }

  public diffDate(a): string {
    let timeNow = Date.now();
    let timeDate =
      new Date(a).getTime() - new Date().getTimezoneOffset() * 60000;
    return ((timeNow - timeDate) / 36e5).toFixed(1);
  }
}
